import React, { ChangeEventHandler, forwardRef, KeyboardEventHandler } from 'react';

import { Input } from '@/components-new/input';

export type NumericTextInputProps = {
  id?: string;
  name?: string;
  onChange?: ChangeEventHandler;
  onBlur?: (event: React.FocusEvent) => any;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  value?: string;
  icon?: React.JSX.Element;
  reverse?: boolean;
  maxWholePlaces?: number;
  maxDecimalPlaces?: number;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
};

export const NumericTextInput = forwardRef<HTMLInputElement, NumericTextInputProps>(
  ({ maxWholePlaces = 10, maxDecimalPlaces = 6, onChange, icon, reverse, ...props }, ref) => {
    const regexp = new RegExp(`^(?!0\\d)\\d{1,${maxWholePlaces}}\\.?$|^(?!0\\d)\\d{1,${maxWholePlaces}}(?:\\.\\d{0,${maxDecimalPlaces}})?$`);

    const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
      const val = event.target.value;
      if (val !== '' && isNaN(parseFloat(val))) {
        event.target.value = '';
      } else if (val !== '' && !regexp.test(val)) {
        return;
      }
      onChange?.(event);
    };

    return <Input {...props} onChange={handleChange} ref={ref} />;
  }
);
